import { API_URL } from "../../API_url/API_URL";
import Axios from 'axios';

export const login = (username, password) => {
    return(dispatch) => {
        Axios.get(API_URL +`/users?username=${username}&password=${password}`)
        Axios.get(API_URL +`/users?email=${username}&password=${password}`)
        .then((res) => {
            console.log(res.data)
            dispatch({
                type: 'LOGIN',
                payload: res.data[0]
            })
            dispatch({
                type: 'CONTOH'
            })
        })
        .catch((err) => {
            dispatch(({
                type: 'LOGOUT'
            }))
        })
    }
}

export const keepLogin = () => {
    return(dispatch) => {
    let username = localStorage.getItem('username')
    Axios.get(API_URL+ `/users?username=${username}`)
    .then((res) => {
        dispatch({
            type: 'LOGIN',
            payload: res.data[0]
        })
    })
    .catch((err) => {
        console.log(err)
    })
    }
}

export const logout = () => {
    return{
        type: 'LOGOUT'
    }
}

export const addToCart = (data) => {
    return{
        type: 'ADD_TO_CART',
        payload: data
    }
} 